import t_es from "./es"
import t_en from "./en"
import t_fr from "./fr"
import t_pt from "./pt"

const t = {
  es: t_es,
  en: t_en,
  fr: t_fr,
  pt: t_pt,
}

export const LANGS = [
  {
    code: "es",
    title: "Español",
    domain: "https://obcocinas.es",
  },
  {
    code: "fr",
    title: "Français",
    domain: "https://obcocinas.fr",
  },
  {
    code: "en",
    title: "English",
    domain: "https://obcocinas.com",
  },
  {
    code: "pt",
    title: "Português",
    domain: "https://obcocinas.pt",
  },
]

export const getTranslationObj = currentLangCode => {
  return t[currentLangCode]
}

export const getOtherLangs = (currentLangCode, currentPageLangs) => {
  const langs = []
  LANGS.map(lang => {
    if (lang.code !== currentLangCode) {
      const currentLang = { ...lang, url: lang.domain }
      currentLang.url = currentPageLangs?.filter(lg => lg.code.substring(0,2) === lang.code)[0]?.url || lang.domain
      langs.push(currentLang)
    }
  })
  return langs
}
export const translateCustom = (type, string, currentLangCode) => {
  const idx = t.es[type].findIndex(element => element == string)
  if (currentLangCode === "es" || idx < 0) {
    return string
  }
  return t[currentLangCode][type][idx]
}
